import { ListSearchItemProps } from "/Models/Generated/ListSearchItemProps";
import "./ListSearchItem.scss";
import { LinkTargetType } from "/Models/Generated/LinkTargetType";
import {
  ArrowLineUpRightIcon,
  ArrowRightIcon,
  DownloadSimpleIcon,
  InfoSmallIcon,
  Label,
} from "/App.Components";
import { ColorTheme } from "/Models/Models/ColorTheme";

const ListSearchItem = ({
  heading,
  linkType,
  label,
  lastUpdated,
  link,
  text,
  downloadLinkAriaLabel,
  openExternalLinkAriaLabel,
}: ListSearchItemProps) => (
  <a
    className="list-search-item-norad"
    href={link}
    target={linkType === LinkTargetType.External ? "_blank" : undefined}
  >
    <div className="list-search-item-norad__text-container">
      {label && <Label text={label} isExternal={false} compact />}
      <div className="list-search-item-norad__heading-and-text-container">
        {heading && (
          <h2 className="list-search-item-norad__heading">
            <span>{heading}</span>
          </h2>
        )}
        {text && (
          <p
            className="list-search-item-norad__text"
            dangerouslySetInnerHTML={{ __html: text }}
          ></p>
        )}
      </div>
      {lastUpdated && <InfoSmallIcon text={lastUpdated} />}
    </div>
    <div className="list-search-item-norad__icon">
      {linkType === LinkTargetType.External && (
        <ArrowLineUpRightIcon
          size="32"
          thickness="Light"
          color={ColorTheme.default}
          ariaLabel={openExternalLinkAriaLabel}
        />
      )}
      {linkType === LinkTargetType.File && (
        <DownloadSimpleIcon
          size="32"
          thickness="Light"
          color={ColorTheme.default}
          ariaLabel={downloadLinkAriaLabel}
        />
      )}
      {linkType === LinkTargetType.Page && (
        <ArrowRightIcon
          size="32"
          thickness="Light"
          color={ColorTheme.default}
        />
      )}
    </div>
  </a>
);

export default ListSearchItem;
